// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collection__grid-split-resize-handle {
    display: flex;
    align-items: center;
    justify-content: center;
}

.assortmentMainTileView .collection__grid-split {
    width: auto;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/product-collection-views/product-collection-grid-view/grid-split/grid-split.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".collection__grid-split-resize-handle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.assortmentMainTileView .collection__grid-split {\n    width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
